export default __webpack_public_path__ + "static/media/tour_areva.1a424e87.jpg";